module.exports = __webpack_public_path__ + "static/img/beersel2.3868bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/beersel2.jpg
// module id = M+sC
// module chunks = 1